/** @jsxImportSource @compiled/react */
import React from 'react';
import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives';

import FieldGroup from '../../../components/FieldGroup';

const styles = cssMap({
  footerLogoWrapper: {
    marginTop: token('space.100'),
  },
  privacyPolicyContainer: {
    marginTop: token('space.100'),
    textAlign: 'left',
    paddingLeft: token('space.0'),
  },
  signUpButtonWrapper: {
    marginTop: token('space.100'),
  },
});

export const FooterLogoWrapper = ({ children }: { children: React.ReactNode }) => (
  <Box xcss={styles.footerLogoWrapper}>{children}</Box>
);

export const PrivacyPolicyContainer = ({ children }: { children: React.ReactNode }) => (
  <Box xcss={styles.privacyPolicyContainer}>{children}</Box>
);

export const SignUpButtonWrapper = ({ children }: { children: React.ReactNode }) => (
  <Box xcss={styles.signUpButtonWrapper}>{children}</Box>
);

export const EmailFieldGroup = styled(FieldGroup)`
  margin-bottom: ${gridSize()}px;
`;
